<template>
  <form>
    
    <md-card v-if="!isRegister">
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Login</h4>
        <p class="category">Let's do this!</p>
      </md-card-header>

      <md-card-content>
         
        <div class="md-layout">
         
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Email</label>
              <md-input v-model="user.email" type="text"></md-input>
            </md-field>
          </div>
          
           <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>password</label>
              <md-input v-model="user.password" type="password"></md-input>
            </md-field>
          </div>
         
           <notifications></notifications>
          <div class="md-layout-item md-size-100 text-right">
            <a href="#" @click="isRegister = true"  class="text-info" style="float:left;font-weight:bold;">No account? Register here</a>
            <md-button  class="md-raised md-success" @click="login()">Login</md-button>
            <div style="float:left">
            OR SIGNIN WITH
            <google-signin-btn label="" customClass="google-signin-button" @click="signin"/>

            </div>
            <div class="" v-if="processing" style="float:right;">
                <ring-loader :loading="true" color="orange" ></ring-loader>
              </div>
          </div>
          </div>
          
      
      </md-card-content>
    </md-card>

    <md-card v-if="isRegister">
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">Register</h4>
        <p class="category">Build your Memry like never before!</p>
      </md-card-header>

      <md-card-content>
         
        <div class="md-layout">
          
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>First Name</label>
              <md-input v-model="user.firstname" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Last Name</label>
              <md-input v-model="user.lastname" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Email</label>
              <md-input v-model="user.email" type="text"></md-input>
            </md-field>
          </div>
          
           <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>password</label>
              <md-input v-model="user.password" type="password"></md-input>
             </md-field>
          </div>
         
           <notifications></notifications>
          <div class="md-layout-item md-size-100 text-right">
            <a href="#" @click="isRegister = false" class="text-info" style="float:left;font-weight:bold;">Already have an account? Login here</a>
            <md-button  class="md-raised md-success" @click="register()">Register</md-button>
          
            <div style="float:left">
            OR SIGNIN WITH
            <google-signin-btn label="" customClass="google-signin-button" @click="signin"/>

            </div>
            <div class="" v-if="processing" style="float:right;">
                <ring-loader :loading="true" color="orange" ></ring-loader>
              </div>
          </div>
          
          
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import ApiService from "@/services/api.service";
import {RingLoader} from '@saeris/vue-spinners'

export default {
  name: "login-form",
   components: {
    RingLoader
  },
  props: {
    dataBackgroundColor: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      user: {},
      isRegister: false,
      processing: false
     }
  },
  computed: {
      
    
  },
   mounted() {

       console.log(this.$props,this.$route);
      this.isRegister = this.$route.name == "Register";
      
      if(this.$route.name == "Logout")
        this.logout();
  },
  beforeDestroy() {
    
  },
  methods: {
    signin() {

      this.processing = true;
      let gAuth;
      let gUser;
          this.$gapi.signIn()
          .then(user => {
              console.log('User',user);
                this.$gapi._libraryLoad('auth2') 
                .then(auth2 => { 
                  //auth2.init(this.$gapi.config); 
                  gAuth = auth2.getAuthInstance();
                  gUser = gAuth.currentUser.get();
                  //console.log(gUser);
                  //console.log('Signed in - validating', user);

                  var finder = function fn(obj, key) {
                        if (_.has(obj, key)) // or just (key in obj)
                            return [obj[key]];
                        // elegant:
                        return _.flatten(_.map(obj, function(v) {
                            return typeof v == "object" ? fn(v, key) : [];
                        }), true);

                        // or efficient:
                        var res = [];
                        _.forEach(obj, function(v) {
                            if (typeof v == "object" && (v = fn(v, key)).length)
                                res.push.apply(res, v);
                        });
                        return res;
                    }
                    var tokenArr = finder(gUser,'id_token');
                    var token = null;
                    if(tokenArr && tokenArr.length > 0)
                      token = tokenArr[0];
                  
                    ApiService.validateGAuth(token).then((resp) => {
                      var data = resp.data;
                      if(data.auth) {
                        if(data.register) {
                            this.notifyVue("Well done! You're registered. Start creating new Memries!",true);
                        } else {
                          this.notifyVue("You're in",true);
                        }
                          this.$router.push({ path: 'dashboard'})
                      } else {
                          console.log('Login failed',data.message);
                    
                          this.notifyVue( data.message,false);
                      }
                      this.processing = false;
                })
              })
              .catch(err => {
                console.error('Auth error - not signed in', err)
                this.processing = false;
                 this.notifyVue("Google authentication is failing! Try refresh or clear cache and try again or use a regular login/signup?",false);
              }) 
              })
              .catch(err => {
                console.error('Sign in Error', err)
                this.processing = false;
                this.notifyVue("Google authentication is failing! Try refresh or clear cache and try again or use a regular login/signup?",false);
              }) 
    },
    login() {
        
      if(this.user.email == null || this.user.email.length == 0) {
        this.notifyVue("Please enter your email.",false);
        return;
      } 


       if(this.user.password == null || this.user.password.length < 5) {
        this.notifyVue("Please enter your password.",false);
        return;
      } 
      this.processing = true;
       console.log('Logging in User',this.user);
  
      ApiService.login(this.user).then((resp) => {
            this.notifyVue("You're in",true);
             this.processing = false;
            this.$router.push({ path: 'dashboard'})
           
        }, (err) => {
            console.log('Login failed',err);
             this.notifyVue( err.data.message,false);
          this.processing = false;
      });
    },

    logout() {
      //logout google also
      this.$gapi.signOut();

      ApiService.logout();
    },

    register() {

      if(this.user.firstname == null || this.user.lastname == null || this.user.firstname.length == 0) {
        this.notifyVue("Please enter your first and lastname.",false);
        return;
      } 

      if(this.user.email == null || this.user.email.length == 0) {
        this.notifyVue("Please enter your email.",false);
        return;
      } 


       if(this.user.password == null || this.user.password.length < 5) {
        this.notifyVue("Please enter a strong password.",false);
        return;
      } 
      
      
      this.user.status = 1;
     this.processing = true;
      console.log('Add User',this.user);
      
      
        ApiService.registerUser(this.user).then((resp) => {
            this.notifyVue("Well done! You're registered. Start creating new Memries!",true);
            this.processing = false;
             this.$router.push({ path: 'dashboard'})
             
        }, (err) => {
            this.processing = false;
            this.notifyVue( err.data.message,false);
          
      });
    },

   
    
 notifyVue(msg, success) {
      var color = success ? 'info' : 'warning';
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: color
      });
    },
  
  }

  
};
</script>
<style type="text/css">
    .google-signin-button {
        display: inline-block;
        border: thin solid #888;
        -webkit-box-shadow: 1px 1px 1px grey;
        box-shadow: 1px 1px 1px grey;
        padding-left: 20%;
        cursor: pointer;
    }
  </style>
